import React from 'react'
import { useIntl } from 'react-intl'
import PeopleContent from './PeopleContent'
import LoanPage from '../../../components/LoanPage'
import withAuth from '../../../components/withAuth'

const People = () => {
	const { formatMessage } = useIntl()
	return (
		<LoanPage
			page="app-loan-details"
			title={formatMessage({ id: 'global.people' })}
			isFullWidth
		>
			<PeopleContent />
		</LoanPage>
	)
}

export default withAuth(People)
